/**
 * @generated SignedSource<<8f97e97bfb5b0bbc5e3427c9711b0174>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "filter",
                    "variableName": "filter"
                }
            ],
            "concreteType": "PublicHoliday",
            "kind": "LinkedField",
            "name": "admin_getHolidays",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isRedDay",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PublicHolidaysPanelQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PublicHolidaysPanelQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "a02e80b2e8cea95ee7d01a3ec8a33980",
            "id": null,
            "metadata": {},
            "name": "PublicHolidaysPanelQuery",
            "operationKind": "query",
            "text": "query PublicHolidaysPanelQuery(\n  $filter: Admin_GetHolidaysFilterInput\n) {\n  admin_getHolidays(filter: $filter) {\n    date\n    id\n    isRedDay\n    title\n  }\n}\n"
        }
    };
})();
node.hash = "ab00ae7557049a965721063e69c080c1";
export default node;
